import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getVitalRows } from "./vital-rows";

export const metadata = {
  tableType: "VitalSignObservations",
  displayName: "Vitals",
  getRows: (bundle: FhirBundleSdk) => getVitalRows({ bundle }),
};
